import React from 'react';
import { Skeleton } from '@mui/material';

const TableSkeletonLoader = ({ columnCount, rowCount = 5, className = '' }) => {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, rowIdx) => (
        <tr key={`skeleton_row_${rowIdx}`} className={className}>
          {Array.from({ length: columnCount }).map((_, colIdx) => (
            <td key={`skeleton_cell_${rowIdx}_${colIdx}`} className='!p-1'>
              <Skeleton variant='text' width={100} height={30} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default TableSkeletonLoader;
